import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { getAllGames, searchGames } from '../services/gamesService';
import GameCard from '../components/GameCard';
import SearchBar from '../components/SearchBar';
import './HomePage.css';

const HomePage = () => {
  const [games, setGames] = useState([]);
  const [filteredGames, setFilteredGames] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [featuredGame, setFeaturedGame] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const allGames = getAllGames().sort(() => Math.random() - 0.5);
    setGames(allGames);
    setFilteredGames(allGames);
    setFeaturedGame(allGames[0]);
    
    const urlParams = new URLSearchParams(window.location.search);
    const subscription = urlParams.get('subscription');
    const token = urlParams.get('token');
    
    if (subscription === 'success' && token) {
      import('../services/subscriptionService').then(({ setAccessAllowed }) => {
        setAccessAllowed(true);
        alert('Subscription successful! You now have access to all premium games.');
        window.history.replaceState({}, document.title, window.location.pathname);
      });
    }
  }, []);

  useEffect(() => {
    if (searchTerm) {
      setFilteredGames(searchGames(searchTerm));
    } else {
      setFilteredGames(games);
    }
  }, [searchTerm, games]);

  const handleGameClick = (gameId) => {
    navigate(`/content/get/${gameId}`);
  };

  const categories = [
    { name: 'Action', games: filteredGames.filter(g => g.category === 'Action') },
    { name: 'Puzzle', games: filteredGames.filter(g => g.category === 'Puzzle') },
    { name: 'Adventure', games: filteredGames.filter(g => g.category === 'Adventure') },
    { name: 'All Games', games: filteredGames }
  ].filter(cat => cat.games.length > 0);

  return (
    <div className="home-page">
      <header className="home-header">
        <h1>⚡ FunGames</h1>
        <SearchBar onSearchChange={setSearchTerm} />
      </header>

      {!searchTerm && featuredGame && (
        <div className="hero-banner" onClick={() => handleGameClick(featuredGame.id)}>
          <div className="hero-overlay"></div>
          <img src={featuredGame.thumbnail} alt={featuredGame.title} className="hero-image" />
          <div className="hero-content">
            <h2>{featuredGame.title}</h2>
            <p>{featuredGame.description}</p>
            <button className="play-btn">▶ Play Now</button>
          </div>
        </div>
      )}

      <div className="content-sections">
        {searchTerm ? (
          <div className="search-results">
            <h2>Search Results for "{searchTerm}"</h2>
            <div className="games-row">
              {filteredGames.map(game => (
                <GameCard key={game.id} game={game} onGameClick={handleGameClick} />
              ))}
            </div>
          </div>
        ) : (
          categories.map(category => (
            <div key={category.name} className="category-section">
              <h3>{category.name}</h3>
              <div className="games-row">
                {category.games.map(game => (
                  <GameCard key={game.id} game={game} onGameClick={handleGameClick} />
                ))}
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default HomePage;
